module.exports = __webpack_public_path__ + "static/media/etsy-app-oauth.4cbf9f08.png";